import { HeartIcon } from 'lucide-preact';

import LockBadge from '@/components/LockBadge';
import useOpenSpeedyFlow from '@/components/SpeedyFlow/hooks/useOpenSpeedyFlow';
import { cn } from '@/lib/utils';

import useToggleMediaLike from './useToggleMediaLike';

const LikeButton = ({ data, onClick = () => {}, mediaId, type, noCount, className }) => {
  const openSpeedyFlow = useOpenSpeedyFlow();
  const { logged, isLiked, likes, toggle } = useToggleMediaLike({
    mediaId,
    type,
    isLiked: data.isLiked,
    likes: data.likes,
  });

  const likeContent = () => {
    if (!logged) {
      // Resume the like once they have an account, so the click that sent them to sign up is not
      // the one thing the sign-up throws away.
      openSpeedyFlow({ kind: 'account', entryPoint: 'like-media' }, () => {
        onClick();
        toggle();
      });
      return;
    }

    onClick();
    toggle();
  };

  return (
    <button
      type="button"
      onClick={likeContent}
      data-component="like-button"
      data-liked={isLiked ? 'true' : 'false'}
      className={cn('preflight preflight-button relative flex items-center justify-center', className)}
    >
      <HeartIcon className={cn('size-[1em]', isLiked && 'fill-current text-system-pink')} />
      {!noCount && (
        <span className="pointer-events-none absolute inset-0 flex items-center justify-center text-white">
          {likes < 1000 ? likes : `${(likes / 1000).toFixed(1)}k`}
        </span>
      )}
      {!logged && <LockBadge />}
    </button>
  );
};

export default LikeButton;
